import React from 'react';
type BrandLogoProps = {
  width?: number;
  height?: number;
  className?: string;
};
export function BrandLogo({
  width = 132,
  height = 30,
  className = ''
}: BrandLogoProps) {
  return <svg viewBox="0 0 260 44" width={width} height={height} role="img" aria-label="Solventum" className={className} data-id="element-16" data-mp="1psnt4bqp223z">
      <text x="0" y="32" fill="currentColor" fontFamily="'Solve Pro Regular', Inter, sans-serif" fontSize="30" letterSpacing="-0.5" data-id="element-17" data-mp="1l0wbwrtfh8qi">
        Solventum
      </text>
    </svg>;
}